// extracted by mini-css-extract-plugin
module.exports = {"content":"Expandable_content__BjdQn","container":"Expandable_container__WvRAZ","open":"Expandable_open__L76g6"};